import { render, staticRenderFns } from "./TransferencesList.vue?vue&type=template&id=01949629&"
import script from "./TransferencesList.vue?vue&type=script&lang=js&"
export * from "./TransferencesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01949629')) {
      api.createRecord('01949629', component.options)
    } else {
      api.reload('01949629', component.options)
    }
    module.hot.accept("./TransferencesList.vue?vue&type=template&id=01949629&", function () {
      api.rerender('01949629', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/transferences/TransferencesList.vue"
export default component.exports